import './_style.scss';

import moment from 'moment';
import React from 'react';
import Barcode from 'react-barcode';
import { Col, Row } from 'reactstrap';

import logo from '../../assets/img/brand/logobf-trim.png';
import logo_ns from '../../assets/img/brand/logo-ns.png';

class PrintCapa extends React.Component {

    constructor(props) {
      super(props);
      this.state = {};
    }

    componentDidUpdate(prevProps){
      if(this.props.autoPrint && this.props.itens && this.props.itens.length > 0 && prevProps.itens !== this.props.itens){
        window.requestAnimationFrame(() => {
          window.print();
        });
      }
    }

    formatDataRecepcao = (data) => {
      const dateMoment = moment(data).isValid() ? moment(data) : moment();
      return dateMoment.utc().format('DD/MM/YYYY');
    }

    createDataObject = ( item ) => {
      const obj = {
        contrato: {},
        user: {},
        originais: 0,
        copias: 0,
        caixaOriginal: 0,
        caixaCopia: 0,
      }
      if (!!this.props.reimpressao) {
        obj.contrato = {
          ...item,
          CodigoEtiqueta: item.Etiqueta,
          originais: item.QtdOriginal,
          copias: item.QtdCopia,
        }
        obj.dataRecepcao = item.DataFinalizacao;
        obj.user = {
          preparacao: item.ResponsavelPreparacao || '',
          recepcao: item.UsuarioRecepcao || '',
        }
        obj.caixaOriginal = item.CaixaOriginal;
        obj.caixaCopia = item.CaixaCopia;
        obj.protocolo = item.CodigoProtocolo;
      } else {
        obj.protocolo = this.props.dadosAdicionais.protocolo;
        obj.dataRecepcao = '';
        obj.contrato = {
          ...item,
          originais: item.qtdOriginais,
          copias: item.qtdCopias,
        };
        obj.user = {
          preparacao: this.props.users.preparacao.name || '',
          recepcao: this.props.users.recepcao.name || '',
        }
        obj.caixaOriginal = this.props.dadosAdicionais.caixaOriginal;
        obj.caixaCopia = this.props.dadosAdicionais.caixaCopia;
      }
      return obj;
    }

    htmlTemplate = ( dataImpressao, copia = false ) => {
      const dataRecepcao = this.formatDataRecepcao(dataImpressao.dataRecepcao);
      const identificador = this.props.chavesDados.filter((chave) => chave.chaveImpressao ).map(el => el)[0];
      const dados = this.props.chavesDados.filter((chave) => !chave.hidden && !chave.chaveImpressao ).map(el => el);

      return (
        <div className={`page-item show`}>
          <div className="recepcao-contrato-capa">
            <div class="barcode-container">
              <Barcode
                value={ dataImpressao.contrato.CodigoEtiqueta }
                format= "CODE128"
                height={100}
                width={5.5}
              />
            </div>

            <div className="logos row">
              <div className="logos__item col-50"><img className="" src={logo_ns} alt=""></img></div>
              <div className="logos__item col-50"><img className="" src={logo} alt=""></img></div>
            </div>

            <h1>Capa de Documento { copia ? "Cópia" : "Original" }</h1>

            <div className="recepcao-contrato-capa__bloco-dados">
              <Row>
                <Col className="col-50">
                  <p><span>Protocolo:</span> { dataImpressao.protocolo }</p>
                  <p><span>{identificador && Object.keys(identificador)[0]}:</span> { identificador && dataImpressao.contrato[identificador[Object.keys(identificador)[0]]] } </p>
                </Col>
                <Col>
                  <p><span>Data Recepção:</span> { dataRecepcao } </p>
                  <p><span>Caixa Temporária:</span> { copia ? dataImpressao.caixaCopia : dataImpressao.caixaOriginal } </p>
                </Col>
                <Col lg={12} className="mt-10">
                  { dados && dados.map(dado => (
                    <p><span>{dado && Object.keys(dado)[0]}:</span> { dado && dataImpressao.contrato[dado[Object.keys(dado)[0]]] } </p>
                  ))}
                  <p><span>Quantidade de páginas { copia ? "Cópias" : "Originais"}:</span> { copia ? dataImpressao.contrato.copias : dataImpressao.contrato.originais }</p>
                  <p><span>Responsável pela preparação:</span> { dataImpressao.user.preparacao || '' } </p>
                  <p><span>Responsável pela recepção:</span> { dataImpressao.user.recepcao || '' }</p>
                </Col>
              </Row>
            </div>

          </div>
        </div>
      )

    }

    renderCapaCopia = (item) => {
      return (this.htmlTemplate(this.createDataObject(item), true));
    }

    renderCapaOriginal = (item) => {
      return (this.htmlTemplate(this.createDataObject(item)));
    }

    renderCapa = () => {
      let paginas = [];
      for(let item of this.props.itens){
        paginas.push( this.renderCapaOriginal(item));
        if (item.qtdCopias > 0 || item.QtdCopia > 0) {
          paginas.push( this.renderCapaCopia(item));
        }
      }
      return paginas;
    }

    render() {
      return (
          <div className="to-print">
            { this.renderCapa() }
          </div>
      );
    }

  }

  export default PrintCapa